import { StoreBaseHandler } from "../../../../infrastructure/base-handlers";
import { setCustomFilterAllValues } from "./actions";
import { SetCustomFilterAllValues } from "./request";

export class SetCustomFilterAllValuesHandler extends StoreBaseHandler {
  async handle(request: SetCustomFilterAllValues) {
    try {
      this.store.dispatch(setCustomFilterAllValues(request.payload));
    } catch (e) {
      console.error(e.message);
    }
  }
}
